module.exports = __webpack_public_path__ + "static/image2-953549f3edb1d71885536001c7e13247.png";